import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';

export const SITE_NAME = 'I giornali del Piemonte';

/** Formato unico del titolo: "[pagina corrente] - [nome del sito]" */
export const buildPageTitle = (page: string): string => `${page} - ${SITE_NAME}`;

/**
 * Per le viste il cui titolo dipende dai dati (nome testata, tipo di ricerca):
 * unisce le parti con " - " e aggiunge il nome del sito.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private readonly title = inject(Title);

  set(...parts: Array<string | null | undefined>): void {
    const page = parts.filter(Boolean).join(' - ');
    this.title.setTitle(page ? buildPageTitle(page) : SITE_NAME);
  }
}

/**
 * Essendo una SPA il browser non ricarica la pagina: il <title> va aggiornato
 * a ogni navigazione nel formato "[pagina corrente] - [nome del sito]".
 * Le route con `data: { titoloDinamico: true }` gestiscono il titolo da sé (la vista
 * cambia senza cambiare route, es. i tab della Ricerca): qui non vengono toccate.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    if (this.hasDynamicTitle(snapshot.root)) return;
    const pageTitle = this.buildTitle(snapshot);
    this.title.setTitle(pageTitle ? buildPageTitle(pageTitle) : SITE_NAME);
  }

  private hasDynamicTitle(route: ActivatedRouteSnapshot): boolean {
    let current: ActivatedRouteSnapshot | null = route;
    while (current?.firstChild) current = current.firstChild;
    return current?.data['titoloDinamico'] === true;
  }
}
